
export const upcomingEvents = [
  {
    id: 1,
    title: 'Chick-fil-A Spirit Night',
    date: 'Thursday, March 19, 2026 | 4:00pm – 8:00pm',
    dateLabel: 'Mar 19',
    description: 'Support Cherokee Youth Football & Cheer at Chick-fil-A Riverstone! Use mobile app code "Cherokee" (available 7am–8pm) or dine in. A portion of proceeds benefits our program.',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/e323340cf84afe06fe0581ac84dbcffa.png',
    status: 'Upcoming'
  },
  {
    id: 2,
    title: 'Your Pie Spirit Night',
    date: 'Wednesday, April 22, 2026 | 11:00am – 9:00pm',
    dateLabel: 'Apr 22',
    description: 'Join us for a Spirit Night at Your Pie! Dine in or carry out and support Cherokee Youth Football & Cheer. A portion of all sales goes directly to our program.',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/c80756392826d598322b47367b8d7b76.jpeg',
    status: 'Upcoming'
  },
  {
    id: 3,
    title: "Coach Holley's Youth Football Camp",
    date: 'June 1–3, 2026',
    dateLabel: 'Jun 1–3',
    description: "Mark your calendars for our varsity head coach's annual youth football camp, June 1–3! More details via the link below!",
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/37f69b3d271c733d1db5fa5ea04caab2.jpeg',
    status: 'Upcoming',
    registerLink: 'https://www.cherokeewarriorsfootball.org/product/2026-cherokee-warrior-youth-football-camp/PGHO72GFBPL4PVW3TWIAN2DH?cp=true&sa=true&sbp=false&q=false'
  },
  {
    id: 4,
    title: "Lil' Warrior Cheer Camp",
    date: 'June 15–17, 2026 | 9:00am – 12:00pm',
    dateLabel: 'Jun 15–17',
    description: "Pre K through 5th grade cheerleaders are invited to our Lil' Warrior Cheer Camp at CHS North Gym! Cost is $80 and includes a shirt & bow. A fun, high-energy camp for young Warriors!",
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/55667cb5c0dd0439ae22a9af8281e67c.jpeg',
    status: 'Upcoming',
    registerLink: 'https://chscompcheer.square.site/product/lil-warrior-cheer-camp-2026/FNXOBJAMGVTPVD24RNKDY5DK'
  },
  {
    id: 5,
    title: '2026 All Sports Camp',
    date: 'June 22–26, 2026 | 9:00am – 3:00pm Daily',
    dateLabel: 'Jun 22–26',
    description: 'In partnership with varsity Head Basketball Coach Joe Veihman, the 2026 All Sports Camp offers a full week of multi-sport fun and skill development at the "Old" Cherokee High School. Cost is $240.',
    image: 'https://static.readdy.ai/image/ad8804c8cf5327b346b1700de5ce7056/d344b152196ca0c888266ae815af0808.jpeg',
    status: 'Upcoming',
    registerLink: 'https://bwfcamps.square.site/2026-summer-camps'
  }
];
